import { useState, useEffect } from 'react';
import API, { fmt } from '@/lib/api';
import { Plus, Trash, X } from '@phosphor-icons/react';

export default function AankopenPage() {
  const [aankopen, setAankopen] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ lev: '', email: '', omschr: '', datum: '', verval: '', excl: '', btwt: '', totaal: '', status: 'concept' });
  const [q, setQ] = useState('');

  const load = () => API.get('/aankopen').then(r => setAankopen(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const u = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    if (!form.lev || !form.omschr) { alert('Vul verplichte velden in'); return; }
    const data = { ...form, excl: parseFloat(form.excl) || 0, btwt: parseFloat(form.btwt) || 0, totaal: parseFloat(form.totaal) || 0 };
    await API.post('/aankopen', data);
    setForm({ lev: '', email: '', omschr: '', datum: '', verval: '', excl: '', btwt: '', totaal: '', status: 'concept' });
    setShowForm(false);
    load();
  };

  const del = async (id) => {
    if (!window.confirm('Aankoop verwijderen?')) return;
    await API.delete(`/aankopen/${id}`);
    load();
  };

  const filtered = aankopen.filter(a => !q || a.lev.toLowerCase().includes(q.toLowerCase()) || a.omschr.toLowerCase().includes(q.toLowerCase()));
  const today = new Date().toISOString().split('T')[0];
  const verval30 = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

  return (
    <div data-testid="aankopen-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="page-heading mb-0">Aankopen</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)} data-testid="toggle-aankoop-form">
          {showForm ? <><X size={14} /> Sluiten</> : <><Plus size={14} weight="bold" /> Nieuwe aankoop</>}
        </button>
      </div>

      {showForm && (
        <div className="inline-form" data-testid="aankoop-form">
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Leverancier</label><input className="field-input" value={form.lev} onChange={u('lev')} placeholder="TechSupply BV" data-testid="aankoop-lev" /></div>
            <div className="form-group"><label className="form-label">E-mail</label><input type="email" className="field-input" value={form.email} onChange={u('email')} placeholder="orders@techsupply.be" data-testid="aankoop-email" /></div>
            <div className="form-group form-full"><label className="form-label">Omschrijving</label><input className="field-input" value={form.omschr} onChange={u('omschr')} placeholder="Servers en hardware" data-testid="aankoop-omschr" /></div>
            <div className="form-group"><label className="form-label">Datum</label><input type="date" className="field-input" value={form.datum || today} onChange={u('datum')} data-testid="aankoop-datum" /></div>
            <div className="form-group"><label className="form-label">Verval</label><input type="date" className="field-input" value={form.verval || verval30} onChange={u('verval')} data-testid="aankoop-verval" /></div>
            <div className="form-group"><label className="form-label">Excl. BTW</label><input type="number" className="field-input" value={form.excl} step="0.01" onChange={u('excl')} placeholder="1700.00" data-testid="aankoop-excl" /></div>
            <div className="form-group"><label className="form-label">BTW</label><input type="number" className="field-input" value={form.btwt} step="0.01" onChange={u('btwt')} placeholder="357.00" data-testid="aankoop-btwt" /></div>
            <div className="form-group"><label className="form-label">Totaal</label><input type="number" className="field-input" value={form.totaal} step="0.01" onChange={u('totaal')} placeholder="2057.00" data-testid="aankoop-totaal" /></div>
            <div className="form-group"><label className="form-label">Status</label><select className="field-input" value={form.status} onChange={u('status')} data-testid="aankoop-status"><option value="concept">Concept</option><option value="verzonden">Verzonden</option><option value="betaald">Betaald</option></select></div>
          </div>
          <div className="flex gap-2 justify-end mt-3">
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Annuleren</button>
            <button className="btn btn-primary" onClick={save} data-testid="save-aankoop-btn">Opslaan</button>
          </div>
        </div>
      )}

      <div className="mb-4">
        <input className="field-input" style={{ maxWidth: 250 }} placeholder="Zoeken..." value={q} onChange={e => setQ(e.target.value)} data-testid="aankoop-search" />
      </div>

      <div className="section-card">
        <div className="section-body">
          <table className="data-table">
            <thead><tr><th>Nummer</th><th>Leverancier</th><th>Omschrijving</th><th>Datum</th><th className="right">Totaal</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {filtered.map(a => (
                <tr key={a.id}>
                  <td className="mono"><span className="doc-nr">{a.id}</span></td>
                  <td>{a.lev}</td>
                  <td>{a.omschr}</td>
                  <td>{a.datum}</td>
                  <td className="right font-medium">{fmt(a.totaal)}</td>
                  <td><span className={`badge ${a.status === 'betaald' ? 'badge-green' : a.status === 'verzonden' ? 'badge-blue' : 'badge-gray'}`}>{a.status}</span></td>
                  <td><button className="btn btn-danger btn-sm" onClick={() => del(a.id)} data-testid={`del-aankoop-${a.id}`}><Trash size={14} /></button></td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan="7" className="text-center text-gray-400 py-8">Geen aankopen</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
